var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import styled, { css } from 'styled-components';
import { v4 as uuidv4 } from 'uuid';
import AppBar, { AppBarSection, AppBarSpacer } from '../../base/AppBar';
import Button from '../../base/Button';
import ButtonGroup from '../../base/ButtonGroup';
import Icon from '../../base/Icon';
import ListView from '../../base/ListView';
import Popup from '../../base/Popup';
import LightBoxLogo from '../../images/lightbox_logo.png';
import AppPicker from '../AppPicker/AppPicker';
import SupportMenu from '../SupportMenu';
import UserAccount from '../UserAccount';
var StyledAppBar = styled(AppBar)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    gap: 0;\n\n    /* Mobile devices (less than 600px display) */\n    @media only screen and (max-width: 600px) {\n        .header-links, .header-links-spacer {\n            display: none !important;\n        }\n\n        .header-overflow, .header-overflow-spacer {\n            display: inline-flex !important;\n        }\n    }\n\n    /* Small devices (portrait tablets and large phones, 600px and up) */\n    @media only screen and (min-width: 600px) {\n        .header-links, .header-links-spacer {\n            display: none !important;\n        }\n\n        .header-overflow, .header-overflow-spacer {\n            display: inline-flex !important;\n        }\n    }\n\n    /* Medium devices (landscape tablets, 768px and up) */\n    @media only screen and (min-width: 768px) {\n        .header-links, .header-links-spacer {\n            display: none !important;\n        }\n\n        .header-overflow, .header-overflow-spacer {\n            display: inline-flex !important;\n        }\n    }\n\n    /* Large devices (laptops/desktops, 1165px and up) */\n    @media only screen and (min-width: 1165px) {\n        .header-links, .header-links-spacer {\n            display: inline-flex !important;\n        }\n\n        .header-overflow, .header-overflow-spacer {\n            display: none !important;\n        }\n    }\n"])));
var StyledButton = styled(Button)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    ", "\n"])), props => css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n        padding: 0.5rem;\n\n        &:hover {\n            color: ", "\n        }\n\n        &.k-focus::before,\n        &:focus::before,\n        &:hover::before {\n            opacity: 0;\n        }\n    "])), props.theme.component.secondaryHover));
var StyledButtonGroup = styled(ButtonGroup)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    ", "\n"])), props => css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n        .k-button {\n            border-radius: ", " !important;\n        }\n    "])), props.theme.component.borderRadiusMd));
var getVariant = active => active ? 'active' : 'secondary';
var openApp = link => {
  if (link.url) {
    if (link.active) {
      window.location = link.url;
    } else {
      window.open(link.url, '_blank');
    }
  }
};
var Header = props => {
  var {
    appPicker,
    id,
    links,
    logoLink,
    onExpandedClick,
    supportMenu,
    userAccount,
    supportButton
  } = props;
  var appBarSpacerProps = useCallback(setWidth => {
    if (setWidth) return {
      style: {
        width: '1rem'
      }
    };
    return null;
  }, []);
  return /*#__PURE__*/React.createElement(StyledAppBar, {
    id: id
  }, onExpandedClick && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AppBarSection, null, /*#__PURE__*/React.createElement(StyledButton, {
    fillMode: "flat",
    onClick: onExpandedClick,
    style: {
      padding: 0
    },
    themeColor: "secondary"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: ['fas', 'bars'],
    size: "lg"
  }))), /*#__PURE__*/React.createElement(AppBarSpacer, {
    style: {
      width: '1rem'
    }
  })), /*#__PURE__*/React.createElement(AppBarSection, null, logoLink ? /*#__PURE__*/React.createElement(StyledButton, {
    fillMode: "flat",
    onClick: () => window.open(logoLink, '_self'),
    style: {
      padding: 0
    }
  }, /*#__PURE__*/React.createElement("img", {
    alt: "LightBox",
    src: LightBoxLogo,
    style: {
      width: '10rem'
    }
  })) : /*#__PURE__*/React.createElement("img", {
    alt: "LightBox",
    src: LightBoxLogo,
    style: {
      width: '10rem'
    }
  })), links && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AppBarSpacer, {
    className: "header-links-spacer"
  }), /*#__PURE__*/React.createElement(AppBarSection, {
    className: "header-links"
  }, /*#__PURE__*/React.createElement(StyledButtonGroup, {
    width: "".concat(150 * links.length, "px")
  }, links.map(link => /*#__PURE__*/React.createElement(Button, {
    key: link.label || uuidv4(),
    onClick: () => openApp(link),
    variant: getVariant(link.active)
  }, link.label || 'NO LABEL'))))), appPicker && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AppBarSpacer, null), /*#__PURE__*/React.createElement(AppBarSection, {
    className: "header-app-picker"
  }, /*#__PURE__*/React.createElement(AppPicker, appPicker))), supportMenu && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AppBarSpacer, appBarSpacerProps(!!appPicker)), /*#__PURE__*/React.createElement(AppBarSection, {
    className: "header-support-menu"
  }, /*#__PURE__*/React.createElement(SupportMenu, supportMenu))), supportButton && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AppBarSpacer, appBarSpacerProps(!!appPicker || !!supportMenu)), /*#__PURE__*/React.createElement(AppBarSection, {
    className: "header-support-button"
  }, /*#__PURE__*/React.createElement(StyledButton, {
    id: supportButton.id,
    onClick: supportButton.onClick,
    fillMode: "flat",
    themeColor: "secondary"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: ['far', 'circle-question'],
    size: "lg"
  })))), userAccount && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AppBarSpacer, appBarSpacerProps(!!appPicker || !!supportMenu || !!supportButton)), /*#__PURE__*/React.createElement(AppBarSection, null, /*#__PURE__*/React.createElement(UserAccount, userAccount))), links && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AppBarSpacer, _extends({
    className: "header-overflow-spacer"
  }, appBarSpacerProps(!!appPicker || !!supportMenu || !!supportButton || !!userAccount))), /*#__PURE__*/React.createElement(AppBarSection, {
    className: "header-overflow"
  }, /*#__PURE__*/React.createElement(HeaderOverflow, {
    links: links
  }))));
};
Header.defaultProps = {
  appPicker: undefined,
  id: undefined,
  links: undefined,
  logoLink: undefined,
  onExpandedClick: undefined,
  supportMenu: undefined,
  supportButton: undefined,
  userAccount: undefined
};
Header.propTypes = {
  /**
   * The AppPicker settings for the component.
   * See the AppPicker documentation for possible settings.
   */
  appPicker: PropTypes.shape({
    applications: PropTypes.arrayOf(PropTypes.shape({
      icon: PropTypes.arrayOf(PropTypes.string),
      name: PropTypes.string,
      onClick: PropTypes.func,
      url: PropTypes.string
    })),
    show: PropTypes.bool,
    title: PropTypes.string
  }),
  /**
   * Sets the id of the Header AppBar.
   */
  id: PropTypes.string,
  /**
   * An array of link settings for the component.
   * The possible link settings are:
   * {
   *      active: PropTypes.bool,
   *      label: PropTypes.string,
   *      url: PropTypes.string,
   * }
   */
  links: PropTypes.arrayOf(PropTypes.shape({
    active: PropTypes.bool,
    label: PropTypes.string,
    url: PropTypes.string
  })),
  /**
   * The link used when the logo is clicked.
   */
  logoLink: PropTypes.string,
  /**
   * The function triggered when the Drawer bars icon is clicked.
   */
  onExpandedClick: PropTypes.func,
  /**
   * The SupportMenu settings for the component.
   * See the SupportMenu documentation for possible settings.
   */
  supportMenu: PropTypes.shape({
    email: PropTypes.string,
    emailSubject: PropTypes.string,
    link: PropTypes.string,
    phone: PropTypes.string,
    show: PropTypes.bool
  }),
  /**
   * The SupportButton settings for the component.
   */
  supportButton: PropTypes.shape({
    id: PropTypes.string,
    onClick: PropTypes.func
  }),
  /**
   * The UserAccount settings for the component.
   * See the UserAccount documentation for possible settings.
   */
  userAccount: PropTypes.shape({
    accountSettings: PropTypes.arrayOf(PropTypes.shape({
      disabled: PropTypes.bool,
      icon: PropTypes.arrayOf(PropTypes.string),
      name: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
      onClick: PropTypes.func,
      url: PropTypes.string,
      visible: PropTypes.bool
    })),
    hideLinkedAccounts: PropTypes.bool,
    linkedAccounts: PropTypes.arrayOf(PropTypes.shape({
      disabled: PropTypes.bool,
      icon: PropTypes.arrayOf(PropTypes.string),
      name: PropTypes.string,
      onClick: PropTypes.func,
      url: PropTypes.string,
      visible: PropTypes.bool
    })),
    onSignOut: PropTypes.func,
    show: PropTypes.bool,
    user: PropTypes.shape({
      email: PropTypes.string,
      name: PropTypes.string
    })
  })
};
var HeaderOverflow = props => {
  var {
    links
  } = props;
  var [show, setShow] = useState(false);
  var anchor = useRef(null);
  var popup = useRef(null);
  var handleClick = event => {
    if (anchor.current.contains(event.target) || popup.current.contains(event.target)) {
      return;
    }
    setShow(false);
  };
  useEffect(() => {
    if (show) {
      document.addEventListener('mousedown', handleClick);
    } else {
      document.removeEventListener('mousedown', handleClick);
    }
    return () => {
      document.removeEventListener('mousedown', handleClick);
    };
  }, [show]);
  if (!links) return null;
  var itemRender = itemProps => {
    var {
      dataItem
    } = itemProps;
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
      onClick: () => openApp(dataItem),
      style: {
        width: '100%'
      },
      variant: getVariant(dataItem.active)
    }, dataItem.label || 'NO LABEL'));
  };
  return /*#__PURE__*/React.createElement("div", {
    ref: anchor,
    style: {
      display: 'inline-flex'
    }
  }, /*#__PURE__*/React.createElement(StyledButton, {
    fillMode: "flat",
    onClick: () => setShow(!show),
    themeColor: "secondary"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: ['fas', 'ellipsis-v'],
    size: "lg"
  })), /*#__PURE__*/React.createElement(Popup, {
    anchor: anchor.current,
    anchorAlign: {
      horizontal: 'right',
      vertical: 'bottom'
    },
    borderless: true,
    onClose: () => setShow(false),
    popupAlign: {
      horizontal: 'right',
      vertical: 'top'
    },
    show: show
  }, /*#__PURE__*/React.createElement("div", {
    ref: popup
  }, /*#__PURE__*/React.createElement(ListView, {
    data: links,
    item: itemRender
  }))));
};
HeaderOverflow.defaultProps = {
  links: undefined
};
HeaderOverflow.propTypes = {
  /**
   * An array of link settings for the component.
   * The possible link settings are:
   * {
   *      active: PropTypes.bool,
   *      label: PropTypes.string,
   *      url: PropTypes.string,
   * }
   */
  links: PropTypes.arrayOf(PropTypes.shape({
    active: PropTypes.bool,
    label: PropTypes.string,
    url: PropTypes.string
  }))
};
export default Header;